function fetchTimeout(url, options, timeout) {
    let controller;
    let signal = {};
    
    if (window.AbortController) {
        controller = new window.AbortController();
        signal = controller.signal;
    }

    const newOptions = Object.assign({}, options, signal);

    return Promise.race([
        window.fetch(url, newOptions),
        new Promise((_, reject) => {
            return setTimeout(() => {
                if (controller) {
                    controller.abort();
                }
                return reject('Fetch timeout');
            }, timeout);
        })
    ]);
}

export function fetchCall({ requestUrl, options = {}, body = 'json', timeout = 10000 } = {}, callback) {
    let response = {
        type: '',
        body: '',
        headers: {}
    };

    fetchTimeout(requestUrl, options, timeout)
        .then((rsp) => {
            if(rsp.headers) {
                rsp.headers.forEach((value, key) => {
                    response.headers[key] = value;
                });
            }
            return rsp[body]()
                .then((data) => {
                    if (!rsp.ok) {
                        const error = {
                            status: rsp.status,
                            statusText: rsp.statusText,
                            message: data
                        };
                        return Promise.reject(error);
                    }
                    return data;
                });
        })
        .then((data) => {
            response.type = 'success';
            response.body = data;
            callback(response);
        })
        .catch((error) => {
            response.type = 'failure';
            response.body = error.message;
            callback(response);
        });
};